<template>
    <div class="content">
        <div class="row animated fadeIn">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title pull-left">
                            Announcements
                        </h4>
                        <button data-toggle="modal"  @click="fixModal" data-target="#newAnnouncementModal" class="btn btn-outline-primary pull-right"><i class="fa fa-bullhorn"></i> Make New Announcement</button>
                    </div>
                    <div class="card-body">
                        <div class="loader" v-if="loading"></div>
                        <table v-else class="table table-striped table-bordered job-announcement-datatable">
                            <thead>
                                <tr>
                                    <th>Announcement</th><th class="text-center">Is Public</th><th class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="announcement in announcements" :key="announcement.id">
                                    <td>
                                        <span v-html="announcement.text"></span>
                                        <small>Created At: <b>{{announcement.createdAt | formatDate}}</b> </small>
                                        <small class="ml-3">Modified At: <b>{{announcement.modifiedAt | formatDate}}</b> </small>
                                    </td>
                                    <td class="text-center">
                                        <span class="badge badge-pill badge-success" v-if="announcement.enabled">Yes</span>
                                        <span class="badge badge-pill badge-danger" v-else>No</span>
                                    </td>
                                    <td width="10%" class="text-center">
                                        <button class="btn btn-sm btn-outline-primary mr-2" @click="openAnnouncement(announcement)"><i class="fa fa-info-circle"></i></button>
                                        <button class="btn btn-sm btn-outline-danger" @click="deleteAnnouncement(announcement)"><i class="fa fa-times"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
      <div class="new-announcement-modal position-relative">
        <div class="modal fade newAnnouncementModal" id="newAnnouncementModal" tabindex="-1" role="dialog" aria-labelledby="newAnnouncementModal" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{(selectedAnnouncement.text === '') ? 'Make New Announcement' : 'Update Announcement'}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Announcement</label>
                  <vue-editor v-model="selectedAnnouncement.text" :editor-toolbar="customToolbar" />
                  <h5 class="mt-3 mb-0" v-if="selectedAnnouncement.text !== ''">Preview</h5>
                  <div v-html="selectedAnnouncement.text"></div>
                </div>
                <div class="form-group">
                  <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : selectedAnnouncement.enabled, 'bootstrap-switch-off bootstrap-switch-focused' : !selectedAnnouncement.enabled }">
                    <div class="bootstrap-switch-container" @click="selectedAnnouncement.enabled = !selectedAnnouncement.enabled">
                      <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                      <span class="bootstrap-switch-label"></span>
                      <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                    </div>

                  </div>
                  <label  class="ml-2" style="font-size: 14px;">
                    Do you want to make this announcement public?
                  </label>
                </div>
                <div class="form-group">
                  <label>Severity</label>
                  <select class="form-control" v-model="selectedAnnouncement.type">
                    <option value="alert-info">Info</option>
                    <option value="alert-warning">Warning</option>
                    <option value="alert-danger">Danger</option>
                  </select>
                </div>
                <div class="form-group">
                  <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : selectedAnnouncement.onlyEmailService, 'bootstrap-switch-off bootstrap-switch-focused' : !selectedAnnouncement.onlyEmailService }">
                    <div class="bootstrap-switch-container" @click="selectedAnnouncement.onlyEmailService = !selectedAnnouncement.onlyEmailService">
                      <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                      <span class="bootstrap-switch-label"></span>
                      <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                    </div>
                  </div>
                  <label class="ml-2" style="font-size: 14px;">
                    Only show to customers having email service
                  </label>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" :disabled="loading" @click="submitAnnouncement()">
                  <div class="loader small_loader" v-if="loading"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
</template>

<script>
    import {db} from "@/firebase/init";
    import swal from 'sweetalert2';
    import { VueEditor } from "vue2-editor";
    export default {
        name: "Announcements",
        components: {
            VueEditor
        },
        data() {
          return {
              announcements: [],
              loading: true,
              customToolbar: [
                  ["bold", "italic", "underline", "strike"],
                  [{ script: "sub" }, { script: "super" }],
                  [{ color: [] }, { background: [] }],
                  ["link"],
                  ["clean"]
              ],
              selectedAnnouncement: {
                  enabled: false,
                  text: '',
                  type: 'alert-info',
                  onlyEmailService: false
              }
          }
        },
        mounted () {
            this.getAnnouncements();
            $('#newAnnouncementModal').on('hidden.bs.modal',  () => {
                this.selectedAnnouncement = {
                    enabled: false,
                    text: '',
                    type: 'alert-info',
                    onlyEmailService: false
                }
            })
        },
        methods: {
          fixModal() {
            /* eslint-disable */
            $(document).ready(function() {
              $(".modal-backdrop").appendTo(".new-announcement-modal");
            });
            /* eslint-enable */
          },
            getAnnouncements () {
                this.announcements = [];
                $(".job-announcement-datatable").DataTable().destroy();
                const announcementQuery = db.collection('announcements').orderBy('createdAt', "desc").limit(100);
                announcementQuery.get().then(docs => {
                    let ann = [];
                    docs.forEach(doc => {
                        ann.push({id: doc.id, ...doc.data()});
                    });
                    this.announcements = ann;
                }).finally(() => {
                    this.loading = false;
                    this.initDataTable();
                })

            },
            initDataTable () {
                /* eslint-disable */
                $(document).ready(function () {
                    $(".job-announcement-datatable").DataTable({
                        ordering: false,
                        retrieve: true,
                        language: {
                            search: "_INPUT_",
                            searchPlaceholder: "Search Announcement",
                            emptyTable: "No announcement exist in the system",
                            size: '40'
                        }
                    });
                    $('#newAnnouncementModal').modal('hide');
                });
                /* eslint-enable */
            },
            openAnnouncement(announcement) {
                this.selectedAnnouncement = {
                    ...announcement,
                    onlyEmailService: announcement.onlyEmailService || false
                };

                $("#newAnnouncementModal").modal('show');
                this.fixModal()

            },
            async submitAnnouncement(){
                this.loading = true;
                if(this.selectedAnnouncement.enabled) {
                    console.log('Start disable the enabled ones...');
                    const announcementRef = await db.collection('announcements').where('enabled', '==', true).get();
                    announcementRef.forEach(async doc => {
                        await db.collection('announcements').doc(doc.id).update({
                            enabled: false
                        })
                    })
                }
                if(this.selectedAnnouncement.id) {
                    console.log('Updating...');
                    await db.collection('announcements').doc(this.selectedAnnouncement.id).update({
                        enabled: this.selectedAnnouncement.enabled,
                        text: this.selectedAnnouncement.text,
                        type: this.selectedAnnouncement.type,
                        onlyEmailService: this.selectedAnnouncement.onlyEmailService || false,
                        modifiedAt: new Date().toISOString()
                    });
                    await this.addLog({
                    message: `User has enabled an Announcement!`,
                    level: "info"
                  })
                } else {
                    console.log('Adding...');
                    await db.collection('announcements').add({
                        enabled: this.selectedAnnouncement.enabled,
                        text: this.selectedAnnouncement.text,
                        type: this.selectedAnnouncement.type,
                        onlyEmailService: this.selectedAnnouncement.onlyEmailService || false,
                        modifiedAt: new Date().toISOString(),
                        createdAt: new Date().toISOString()
                    });
                  await this.addLog({
                    message: `User has added new announcement!`,
                    level: "info"
                  })
                }
                this.getAnnouncements();
            },
            deleteAnnouncement (announcement) {
                swal({
                    title: 'Are you sure?',
                    text: 'Are you sure to delete this announcement!',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: "#6ACF98",
                    cancelButtonColor: "#EE8057"
                }).then((result) => {
                    if(result.value) {
                        this.loading = true;
                        db.collection('announcements').doc(announcement.id).delete().then(() => {
                            swal('Success!', 'Announcement has been deleted successfully', 'success');
                            this.getAnnouncements();
                            this.addLog({
                              message: `User has deleted an Announcement!`,
                              level: "info"
                            })
                        });
                    }
                })

            }
        }
    }
</script>

<style scoped>

</style>
